import { Grid, Skeleton } from '@purpur/library';
import styled from 'styled-components';

import { getPurpurColor, purpurMedia } from '@telialt/common-theme/src/purpurSelectors';

type SkeletonDescriptionTextProps = {
    $isShorter?: boolean;
};

export const ProductDetailsSkeletonWrapper = styled(Grid)`
    margin: 5rem auto;
`;

export const GallerySkeleton = styled(Skeleton)`
    height: 24rem;
    margin-bottom: 2rem;
`;

export const SkeletonDescriptionWrapper = styled.div`
    padding: 1rem;
    margin: 1rem;
    height: 12rem;
    border-bottom: 1px solid ${getPurpurColor('gray50')};
`;

export const SkeletonDescriptionHeading = styled(Skeleton)`
    height: 1.5rem;
`;

export const ProductTitleSkeleton = styled(Skeleton)`
    width: auto;
    height: 3rem;
    ${purpurMedia('lg')`
        margin-left: 2rem;
    `}
`;

export const SkeletonDescriptionParagraphWrapper = styled.div`
    height: 1rem;
    padding: 2rem 5rem 25% 1.5rem;
`;

export const SkeletonDescriptionText = styled(Skeleton)<SkeletonDescriptionTextProps>`
    height: 1rem;
    margin-bottom: 1rem;
    width: ${({ $isShorter }) => ($isShorter ? '80%' : '100%')};
`;
